import React, { FC } from 'react';
import classNames from 'classnames';
import useSessionList from './useSessionList';
import SessionItem from './SessionItem';
import MfButton from '../UI/Button/MfButton';
import MfLinearSimpleProgress from '../UI/Progress/MfLinearSimpleProgress';
import styles from './SessionList.module.scss';

const SessionList: FC = () => {
  const { response, loading, closeSession, closeAllSessions } =
    useSessionList();

  if (loading) {
    return <MfLinearSimpleProgress />;
  }

  return (
    <div className={styles.list}>
      <div className="mb-3">
        <MfButton
          onClick={closeAllSessions}
          size="small"
          variant="outlined"
          color="secondary"
        >
          Завершить все сессии
        </MfButton>
      </div>
      {response.map((v) => (
        <div
          className={classNames(['my-3', styles.listItemWrapper])}
          key={v.id}
        >
          <SessionItem onClose={closeSession} data={v} />
        </div>
      ))}
    </div>
  );
};

export default SessionList;
